<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  name: "JobsList",
  data() {
    return {
      opportunity: null,
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob,
  },
};
</script>

<template>
  <div class="smart-group">
    <div class="container">
      <h2>Mais forte. Mais rápido. Desafiando seus limites.</h2>
      <p>
        Bio Ritmo sempre foi sinônimo de pioneirismo, desafio e alta qualidade,
        por isso seu propósito é proporcionar experiências exclusivas e
        diferentes, que entreguem resultados e performance para que os clientes
        possam sempre superar os próprios limites e continuarem se desafiando.
      </p>
    </div>
    <div class="bg"></div>
    <div class="container inscritions">
      <h2 class="text-center">
        Inscreva-se no <br />
        Banco de Talentos da Bio Ritmo:
      </h2>

      <div class="row">
        <div class="col-lg-4 col-md-4">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/bio1.jpg" alt="" />
            </div>
            <div class="text">
              <h3>PROFESSOR DE MUSCULAÇÃO</h3>
              <router-link
                :to="'/vagas/144059-bio-ritmo-banco-de-talentos-professor-de-musculacao/inscricao'"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 mt-4 mt-md-0">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/bio2.jpg" alt="" />
            </div>
            <div class="text">
              <h3>PROFESSOR DE NATAÇÃO</h3>
              <router-link
                to="/vagas/144065-bio-ritmo-banco-de-talentos-professor-de-natacao/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 mt-md-0 mt-4">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/bio3.jpg" alt="" />
            </div>
            <div class="text">
              <h3>PROFESSOR DE GINÁSTICA</h3>
              <router-link
                to="/vagas/144060-bio-ritmo-banco-de-talentos-professor-de-ginastica/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>


      <div class="col-lg-4 col-md-4 mt-md-4 mt-4">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/bio4.jpg" alt="" />
            </div>
            <div class="text">
              <h3>PROFESSOR DE HIDROGINÁSTICA</h3>
              <router-link
                to="/vagas/144192-bio-ritmo-banco-de-talentos-professor-de-hidroginastica/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>
            <div class="col-lg-4 col-md-4 mt-md-4 mt-4">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/bio5.jpg" alt="" />
            </div>
            <div class="text">
              <h3>INSTRUTOR DE YOGA</h3>
              <router-link
                to="/vagas/144067-bio-ritmo-banco-de-talentos-instrutor-de-yoga/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>
            <div class="col-lg-4 col-md-4 mt-md-4 mt-4">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/bio6.jpg" alt="" />
            </div>
            <div class="text">
              <h3>INSTRUTOR DE PILATES</h3>
              <router-link
                to="/vagas/144190-bio-ritmo-banco-de-talentos-instrutor-de-pilates/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 mt-md-4 mt-4">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/bio7.jpg" alt="" />
            </div>
            <div class="text">
              <h3>ESTAGIÁRIO DE EDUCAÇÃO FÍSICA</h3>
              <router-link
                to="/vagas/144066-bio-ritmo-banco-de-talentos-estagiario-de-musculacao/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>
            <div class="col-lg-4 col-md-4 mt-md-4 mt-4">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/bio8.jpg" alt="" />
            </div>
            <div class="text">
              <h3>AUXILIAR DE MANUTENÇÃO</h3>
              <router-link
                to="/vagas/144069-bio-ritmo-banco-de-talentos-auxiliar-de-manutencao/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>
            <div class="col-lg-4 col-md-4 mt-md-4 mt-4">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/bio9.jpg" alt="" />
            </div>
            <div class="text">
              <h3>CONSULTOR DE VENDAS</h3>
              <router-link
                to="/vagas/144070-bio-ritmo-banco-de-talentos-consultor-de-vendas-geracao-de-visitas/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.inscritions {
  .row {
    width: 100%;
    margin: 0 auto;
    margin-top: 3rem;
    @include media-breakpoint-down(md) {
      width: 100%;
    }
  }
}

.inscritions_card {
  background: #ffffff;
  box-shadow: 0px 4px 12px 8px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  border-top: 6px solid #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .text {
    width: 100%;
    padding: 2rem 4rem;
    text-align: center;
    min-height: 200px;
  }
  h3 {
    font-weight: bold;
    height: 90px;
    font-size: 2rem !important;
    text-align: center !important;
  }
  a {
    text-align: center;
    background-color: #000;
    color: #fff;
    font-size: 1.6rem;
    font-weight: 300;
    width: 100%;
    display: block;
    padding: 0.5rem 1rem;
    transition: all 0.2s ease-in-out;
    &:hover {
      background-color: theme-color(primary);
    }
  }
  .img {
    height: 200px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
}

.smart-group {
  margin: 6rem 0px 5rem 0px;
  p {
    font-size: 1.8rem;
    color: #000;
    line-height: calc(1.8rem * 1.2);
  }
  .bg {
    height: 600px;
    overflow: hidden;
    background: url(../../assets/images/smart_fit/jobsl1.jpg) no-repeat center;
    background-size: cover;
    margin-top: 3rem;
    background-position: 0px -40px;
    @include media-breakpoint-down(sm) {
      height: 300px;
    }
  }
  .inscritions {
    padding: 5rem 0px;
    h2 {
      font-size: 4.3rem !important;
      font-family: "Gotham HTF" !important;
      @include media-breakpoint-down(sm) {
        font-size: 2rem !important;
      }
    }
  }
}
</style>